import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { VproService } from 'src/app/service/vpro/vpro.service';
import { Utils } from 'src/app/common/utils';
import Swal from "sweetalert2";
import { formatDate } from "@angular/common";
import { UntypedFormBuilder, Validators, UntypedFormGroup, UntypedFormControl } from "@angular/forms";
import { ConfirmedValidator } from 'src/app/common/passwordValidator';
const Toast = Swal.mixin({
  toast: true,
  position: "top",
  showConfirmButton: false,
  timer: 3500,
});
@Component({
  selector: 'app-patient-add',
  templateUrl: './patient-add.component.html',
  styleUrls: ['./patient-add.component.css']
})
export class PatientAddComponent implements OnInit {
  public user: any;
  patientForm: UntypedFormGroup;
  dateFormat = Utils.DATE_FORMAT;
  relation = Utils.ADD_RELATION;
  gender = Utils.GENDER;
  maxDate = Utils.today;
  minDate = Utils.minDobDate;
  email_id: string;
  validOTP: boolean = false;
  wrongOTP: boolean = false;
  phone: any;
  currentDate = Utils.maxDate;
  miniDate = Utils.miniDate;
  constructor(
    private router: Router,
    private _formBuilder: UntypedFormBuilder,
    private service: VproService,
    private spinner: NgxSpinnerService,
  ) {

  }

  ngOnInit() {
    this.email_id = localStorage.getItem("LogUsr");

    this.patientForm = this._formBuilder.group({
      first_name: ["", [Validators.required, Validators.maxLength(30), Validators.pattern(Utils.alphaSpaceRegex)]],
      last_name: ["", [Validators.required, Validators.maxLength(30), Validators.pattern(Utils.alphaSpaceRegex)]],
      dob: ["", [Validators.required]],
      email_id: [""],
      gender: ["", [Validators.required]],
      relation: ["", [Validators.required]],
      contact_no: ['', [Validators.required, Validators.maxLength(10), Validators.minLength(10), Validators.pattern(Utils.numberRegex)]],
      otp: ['', Validators.required],
    });
  }


  public addMember() {
    let data = {
      ...this.patientForm.value,
    };
    // Remove any empy fields
    data = Utils.removeNullAndEmpty(data);
    data['email_id'] = this.email_id;
    data['contact_no'] = this.phone;
    if (data.dob) {
      data.dob = data.dob.year + "-" + data.dob.month + "-" + data.dob.day
      // data.dob = formatDate(data.dob, "yyyy-MM-dd", "en-US");
    }
    this.spinner.show();
    this.service.addPatients(data).subscribe(
      () => {
        this.spinner.hide();
        // SweetAlert

        const Toast = Swal.mixin({
          toast: true,
          position: "top",
          showConfirmButton: false,
          timer: 3500,
        });

        Toast.fire({
          type: "success",
          title: "Patient profile has been created successfuly",
        });
        this.router.navigate(["/patient/members"]);
      },
      (error) => {
        this.spinner.hide();
        const Toast = Swal.mixin({
          toast: true,
          position: "top",
          showConfirmButton: false,
          timer: 3500,
        });
        Toast.fire({
          type: "error",
          title: error && error.error && error.error.message ? error.error.message : "Something went wrong. Please try again later.",
        });
      }
    );
  }

  cancel() {
    this.router.navigate(["/patient/members"]);
  }

  getControl(field: string): UntypedFormControl {
    return this.patientForm.get(field) as UntypedFormControl;
  }

  requestOTP() {
    if (this.patientForm.value.contact_no) {
      if (this.patientForm.value.otp)
        return;

      if (!this.patientForm.value.contact_no.match(Utils.numberRegex) || this.patientForm.value.contact_no.length != 10) {
        this.showToast("error", "Invalid Contact No, Please enter a valid contact number");
        this.patientForm.controls["contact_no"].reset();
        return;
      }

      this.spinner.show();
      this.service
        .requestOTP({ contact_no: this.patientForm.value.contact_no })
        .subscribe(
          (res) => {
            this.spinner.hide();
            this.showToast("success", res.message);
          },
          (error) => {
            this.spinner.hide();
            this.showToast("error", "Something went wrong. Please try again.");
          }
        );
    }
  }

  validateOTP() {
    if (this.validOTP)
      return;
    if (this.patientForm.value.contact_no && this.patientForm.value.otp) {
      this.spinner.show();
      this.service
        .validateOTP({
          contact_no: this.patientForm.value.contact_no,
          otp: this.patientForm.value.otp,
        })
        .subscribe(
          (res) => {
            this.spinner.hide();
            this.showToast("success", res.message);
            this.otpValidated();
          },
          (err) => {
            console.log(err);
            this.spinner.hide();
            let message =
              err && err.error && err.error.message && err.error.message.message
                ? err.error.message.message
                : "Something wrong. Couldn't delete appointment.";
            this.showToast("error", message);
            if (err.error.message.message) {
              this.wrongOTP = true;
              return;
            }
          }
        );
    }
  }

  otpValidated() {
    this.wrongOTP = false;
    this.phone = this.patientForm.value.contact_no;
    this.patientForm.controls["contact_no"].disable();
    this.patientForm.controls["otp"].disable();
    this.validOTP = true;
  }

  showToast(type, title) {
    Toast.fire({
      type: type,
      title: title,
    });
  }

}
